/**
 * convert a symbolic style from src/types/css.d.ts to a number for use in pure react-native components
 */
export const styleToNumber = (styleString: string) => +(styleString || '0').replace(/[^0-9.]/g, '');
